<template>
  <div class="split-view">
    <div class="sidebar" :class="{ collapsed }">
      <div class="sidebar-content">
        <slot name="sidebar" />
      </div>
      <button v-if="collapsible" class="collapse-button" @click="collapsed = !collapsed">
        <Icon :name="collapsed ? 'arrow_right' : 'arrow_left'" />
      </button>
    </div>
    <div class="main">
      <div ref="scrollArea" class="main-content">
        <slot name="main" />
        <slot name="save" />
        <slot name="cancel" />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@alpha/ink'

export default {
  components: {
    Icon
  },
  props: {
    collapsible: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      collapsed: false
    }
  }
}
</script>

<style scoped>
.split-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.sidebar {
  display: flex;
  flex-direction: column;
  height: 35%;
  border-bottom: 1px solid #ddd;
}

.sidebar.collapsed {
  height: 10px;
}

.sidebar-content {
  flex: 1;
  overflow-y: scroll;
  position: relative;
}

.collapsed .sidebar-content {
  height: 0;
  overflow: hidden;
}

.collapse-button {
  width: 100%;
  border: 0;
  border-top: 1px solid #ddd;
  height: 10px;
  padding: 0;
  background: transparent;
  cursor: pointer;
}

.collapsed .collapse-button {
  border-top: 0;
}

.main {
  display: flex;
  height: 65%;
  flex: 1 0;
}

.main-content {
  flex: 1;
  overflow-y: scroll;
}

@media (min-width: 769px) {
  .split-view {
    flex-direction: row;
  }

  .sidebar {
    width: 30%;
    height: 100%;
    flex-direction: row;
    border-right: 1px solid #ddd;
    border-bottom: 0;
  }

  .sidebar.collapsed {
    height: 100%;
    width: auto;
  }

  .collapse-button {
    width: 10px;
    height: 100%;
    border-left: 1px solid #ddd;
    border-top: 0;
  }

  .collapsed .sidebar-content {
    height: auto;
    width: 0;
    overflow: hidden;
  }

  .main {
    width: 70%;
    height: 100%;
  }
}
</style>
